<template lang="pug">
  .b-onboarding__footer
    .b-onboarding__footer-left
      span.btn.btn-back(v-if="!noBack" @click="$parent.$parent.back")
        span.btn-back__text Back
        i.btn-back__icon
          img(:src="`${config.baseUri}/images/client/saas-onboarding/onboarding-btn-back.svg`")
    .b-onboarding__footer-right
      span.btn.btn-primary.btn-lg(@click="next" :disabled="disabled" :class="{ disabled }") {{ getStarted ? 'Get started' : 'Next' }}
        i
          img(:src="`${config.baseUri}/images/client/saas-onboarding/onboarding-btn-next.svg`")
      
</template>

<script>
export default {
  name: 'onboarding-back-and-forth',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    noBack: {
      type: Boolean,
      default: false,
    },
    getStarted: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    config: window.addiesaas.config,
  }),

  methods: {
    async next() {
      if (this.getStarted) {
        const { domain } = await this.$parent.update({ complete: true })
        window.location.href = `https://${domain}/login/tenant/sso?token=${this.$store.getters.authToken}`
      } else {
        if (!this.disabled) {
          this.$parent.$parent.next()
        }
      }
    },
  }
}
</script>
